import React from "react";

const AboutSection = () => {
  return (
    <>
      <section id="profile" className="about">
        <div className="container" data-aos="fade-up">
          <div className="row position-relative">
            <div
              className="col-lg-5 about-img"
              style={{
                backgroundImage: "url(../assets/img/about.jpg)",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
              }}
            ></div>

            <div className="col-lg-10">
              {/* <h2>ABOUT</h2> */}
              <div className="our-story">
                <p style={{ textAlign: "justify" }}>
                  DataProSDGs is a global movement of people and organizations
                  committed to using data protection regulation and the concept
                  of information technology to support the attainment of the UN
                  Sustainable Development Goals (SDGS) by 2030.
                  <br /> <br /> Coming as a research led innovation, DataProSDGs
                  is a social movement responding to a global call to action for
                  people and planet, encouraging the ethical use of data to
                  support the achievement of the goals.
                  <br /> <br /> Working with individuals, governments,
                  communities, businesses, fund supporters and others, we are
                  forming inclusive and locally-led collaborations, creating
                  connections and awareness across borders and cultures.
                  Together, we are implementing bold new strategies and
                  sustainable solutions to achieve a brighter future for all.
                  <br /> <br />
                  Our motivation is that we have a greater chance of achieving
                  the 17 United Nations Goals when we collaborate to use
                  technology and data protection activities to confront poverty,
                  eliminate hunger and improve well-being of people living on
                  the planet of earth. By working together, we are able to share
                  ideas, improve access to information, deploy resources more
                  effectively and develop inclusive solutions that improve the
                  quality of people’s lives.
                  <br /> <br /> This research work will witness a rising tide of
                  committed people and organizations from various background,
                  race and ethnicity, coming together to collaborate in deep and
                  meaningful ways to pave ways for the attainment of the goals
                  using data protection regulation and technology-riding
                  innovations. We invite you to collaborate with us and join our
                  growing community.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;
